// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"5e1a6fe4","191":"6d0b3331","467":"181af65a"}[chunkId] + ".chunk.css";
};